module.exports = __webpack_public_path__ + "img/memoryIcon.9f425cb8.png";